export default {
  path: '/carga-de-selos-virtuais',
  component: () => import('@/components/pages/VirtualSealsLoad/VirtualSealsLoads.vue')
}
